"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.models.source': 'Źródło AI',
    'ai.models.custom_list': 'Twoje Modele',
};
